import { atom } from "jotai";

import { currentModalStepAtom } from "../../stores";

export const enterAddPlayersStepAtom = atom(
  null,
  (_get, set, payload?: { bookingIndex?: number } | null) => {
    set(
      currentModalStepAtom,
      payload?.bookingIndex == null
        ? { type: "AddPlayer" }
        : { type: "AddPlayer", bookingIndex: payload.bookingIndex }
    );
  }
);
